import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as indexGuideActions } from '../../appstate/placeGuide';
import { getIndexGuideContent } from '../../services/seoService';
import sliceNamespace from '../../types';

const namespace = 'ACTIONS/FETCH_INDEX_DATA';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

const logger = Logger.getLogger('fetchIndexGuide');

function fetchIndexGuide(localeAwareIndexGuideId, transMode, locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(localeAwareIndexGuideId));

        try {
            const { result } = await getIndexGuideContent({
                locale,
                transMode,
            });

            dispatch(indexGuideActions.setPlaceGuideContent(result, localeAwareIndexGuideId));
            return result;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: 'set index guide failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareIndexGuideId, undefined, error));
        }
    };
}

const fetchIndexGuideSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_INDEX_GUIDE';
    },
};

const fetchIndexGuideAction = {
    fetchIndexGuide,
    ...fetchIndexGuideSelectors,
};

export {
    fetchIndexGuideAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
